import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import { ApprovatorUser, PageRequest, PageRequestClient, PageResponse, Quotation, ResponseLegacyDataDTO, State } from '../clients/interface/data.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesQuoteService {

  constructor(private http: HttpClient) {}

  getCotizaciones(request: PageRequest): Observable<PageResponse> {
    let queryParams = new HttpParams()
    .set('states', request.states)
    .set('pageSize', request.pageSize)
    .set('search', request.search)
    .set('page', request.page)
    .set('orderBy', request.orderBy)
    .set('orderDirection', request.orderDirection)
    .set('approvatorId', request.approvatorId)
    const endpoint = `${environment.apiUrl}/SalesQuote`;
    return this.http.get<PageResponse>(endpoint, {params: queryParams});
  }

  getCotizacionesClient(request: PageRequestClient, companyId: number): Observable<PageResponse> {
    let queryParams = new HttpParams()
    .set('companyId', companyId)
    .set('states', request.states)
    .set('search', request.search)
    .set('orderBy', request.orderBy)
    .set('orderDirection', request.orderDirection)
    .set('page', request.page)
    .set('pageSize', request.pageSize)

    const endpoint = `${environment.apiUrl}/SalesQuote/Company/${companyId}`;
    return this.http.get<PageResponse>(endpoint, {params: queryParams});
  }

  getSalesQuoteById(id: number): Observable<Quotation> {
    const endpoint = `${environment.apiUrl}/SalesQuote/${id}`;
    return this.http.get<Quotation>(endpoint);
  } 

  getStateCotizaciones(): Observable<State[]> {
    const endpoint = `${environment.apiUrl}/SalesQuote/states`;
    return this.http.get<State[]>(endpoint);
  }

  approveCotizacion(request: any): Observable<any> {
    const endpoint = `${environment.apiUrl}/SalesQuote/${request.idCotizacion}/discount/approve`;
    return this.http.post<any>(endpoint, request);
  }

  rejectCotizacion(request: any): Observable<any> {
    const endpoint = `${environment.apiUrl}/SalesQuote/${request.idCotizacion}/discount/reject`;
    return this.http.post<any>(endpoint, request);
  }

  getApprovators(): Observable<ApprovatorUser[]> {
    const endpoint = `${environment.apiUrl}/SalesQuote/approvators`;
    return this.http.get<ApprovatorUser[]>(endpoint);
  }
  
  getLegacySummaryInfo(rut: string): Observable<ResponseLegacyDataDTO> {
    const endpoint = `${environment.apiUrl}/Scoring/${rut}/LegacyData`;
    return this.http.get<ResponseLegacyDataDTO>(endpoint);
  }

}